const e = up.element;
up.OverlayFocus = class OverlayFocus {
    constructor(layer) {
        this._layer = layer;
        this._focusElement = this._layer.getFocusElement();
        this._trapFocus = this._layer.trapFocus;
    }
    moveToFront() {
        if (this._active) {
            return;
        }
        this._active = true;
        this._unsetAttrs = e.setAttrsTemp(this._focusElement, {
            'tabindex': '0',
            'role': 'dialog',
            'aria-modal': this._trapFocus.toString()
        });
        if (this._trapFocus) {
            this._untrapFocus = up.on('focusin', (event) => this._onFocus(event));
            this._focusTrapBefore = e.affix(this._focusElement, 'beforebegin', 'up-focus-trap[tabindex=0]');
            this._focusTrapAfter = e.affix(this._focusElement, 'afterend', 'up-focus-trap[tabindex=0]');
        }
    }
    moveToBack() {
        this.teardown();
    }
    teardown() {
        if (!this._active) {
            return;
        }
        this._active = false;
        this._unsetAttrs();
        if (this._trapFocus) {
            this._untrapFocus();
            this._focusTrapBefore.remove();
            this._focusTrapAfter.remove();
        }
    }
    _onFocus(event) {
        const { target } = event;
        if (this._processingFocusEvent || up.layer.isWithinForeignOverlay(target)) {
            return;
        }
        this._processingFocusEvent = true;
        if (target === this._focusTrapBefore) {
            this._focusEnd();
        }
        else if ((target === this._focusTrapAfter) || !this._layer.contains(target)) {
            this._focusStart();
        }
        this._processingFocusEvent = false;
    }
    _focusStart(focusOptions) {
        up.focus(this._focusElement, focusOptions);
    }
    _focusEnd() {
        this._focusLastDescendant(this._layer.getBoxElement()) || this._focusStart();
    }
    _focusLastDescendant(element) {
        for (let child of [...element.children].toReversed()) {
            if (up.viewport.tryFocus(child) || this._focusLastDescendant(child)) {
                return true;
            }
        }
    }
};
